import { c as _c } from "react/compiler-runtime";
import { NewTag } from "@components/common/new-tag";
import { PreservingNavLink } from "@components/common/preserve-navigation/preserving-nav-link";
import { Badge, ListItem, ListItemButton, ListItemIcon, ListItemText, Text, Tooltip } from "@flat-ui";
import { DateTimeUtils } from "@stellar/utils";
import { withEllipsis } from "@styles/common-styles";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Renders a single sidebar item */
export function SidebarListItem(t0) {
  const $ = _c(14);
  const {
    isSidebarFullSize,
    sidebarItem,
    onClick
  } = t0;
  let t1;
  if ($[0] !== isSidebarFullSize || $[1] !== sidebarItem.hideNewBadgeDate || $[2] !== sidebarItem.icon || $[3] !== sidebarItem.title) {
    t1 = t2 => {
      const {
        isActive: isActive_0
      } = t2;
      return <ListItem disablePadding={true} sx={{
        display: "block",
        my: 0.5,
        ...(isActive_0 && {
          borderLeft: `3px solid ${PALETTE_VARS.primary.main}`
        })
      }}><ListItemButton selected={isActive_0} sx={{
          minHeight: 48,
          justifyContent: isSidebarFullSize ? "initial" : "center",
          pl: "18px",
          pr: "2px",
          "&:hover": {
            color: "primary.main",
            "& .MuiListItemIcon-root": {
              color: "primary.main"
            }
          },
          ...(isActive_0 && {
            pl: 2.25,
            color: "primary.main",
            "& .MuiListItemIcon-root": {
              color: "primary.main"
            }
          })
        }}><ListItemIcon sx={{
            color: "text.primary",
            minWidth: 0,
            mr: isSidebarFullSize ? 1 : "auto",
            justifyContent: "center",
            alignItems: "center",
            height: "24px",
            width: "24px",
            ...(isActive_0 && {
              color: "primary.main"
            })
          }}>{!isSidebarFullSize && DateTimeUtils.shouldShowNewTag(sidebarItem.hideNewBadgeDate) ? <Badge variant="dot" color="secondary">{sidebarItem.icon}</Badge> : sidebarItem.icon}</ListItemIcon><ListItemText disableTypography={true} sx={{
            opacity: isSidebarFullSize ? 1 : 0,
            fontSize: "14px"
          }}><Text variant="bodyM" component="div" sx={{
              ...withEllipsis,
              fontWeight: isActive_0 ? "600" : "normal",
              color: "inherit"
            }}>{sidebarItem.title}</Text></ListItemText>{isSidebarFullSize && DateTimeUtils.shouldShowNewTag(sidebarItem.hideNewBadgeDate) && <ListItemIcon sx={{
            justifyContent: "end"
          }}><NewTag /></ListItemIcon>}</ListItemButton></ListItem>;
    };
    $[0] = isSidebarFullSize;
    $[1] = sidebarItem.hideNewBadgeDate;
    $[2] = sidebarItem.icon;
    $[3] = sidebarItem.title;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== onClick || $[6] !== sidebarItem.dataTestId || $[7] !== sidebarItem.identity || $[8] !== sidebarItem.route || $[9] !== t1) {
    t2 = <PreservingNavLink onClick={onClick} key={sidebarItem.identity} data-testid={sidebarItem.dataTestId} to={sidebarItem.route} style={_temp}>{t1}</PreservingNavLink>;
    $[5] = onClick;
    $[6] = sidebarItem.dataTestId;
    $[7] = sidebarItem.identity;
    $[8] = sidebarItem.route;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== sidebarItem.title || $[12] !== t2) {
    t3 = <Tooltip component="div" title={sidebarItem.title}>{t2}</Tooltip>;
    $[11] = sidebarItem.title;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
function _temp(t0) {
  const {
    isActive
  } = t0;
  return {
    color: isActive ? PALETTE_VARS.primary.main : "inherit",
    textDecoration: "none"
  };
}